import React from 'react';
import PropTypes from 'prop-types';

import SmartAssignmentSelect from '../../smart_assignment_select';

const SmartAssignmentSelectFormik = props => {
  const { field, form } = props;
  const { name, value } = field;
  const { setFieldValue } = form;

  const onChange = newValue => {
    setFieldValue(name, newValue);
  };

  return <SmartAssignmentSelect {...props} onChange={onChange} value={value} />;
};

SmartAssignmentSelectFormik.propTypes = {
  field: PropTypes.shape({}),
  form: PropTypes.shape({ values: PropTypes.shape({}) }),
};

export default SmartAssignmentSelectFormik;
